/* Farmacias LF · utilidades compartidas del sistema Cápsula.
   Cada sección carga su propio JS si necesita más; aquí solo va lo común:

   1. Paneles (hojas inferiores y cajones laterales)
      <button data-lf-open="lf-filtros">Filtrar</button>
      <div id="lf-filtros" class="lf-panel" hidden> ... <button data-lf-close>Cerrar</button></div>
      Al abrir: quita [hidden], agrega .lf-is-open, bloquea el scroll del body y muestra el fondo .lf-scrim.
      Se cierra con [data-lf-close], con Escape o tocando el fondo.

   2. Barra fija que aparece cuando un elemento sale de la pantalla
      <div data-lf-sticky-watch="#lf-comprar"> ... </div>   (la barra)
      Agrega .lf-is-visible a la barra cuando #lf-comprar ya no se ve.

   3. Menú de las apps de delivery (snippets/lf-apps-delivery.liquid)
      <details data-lf-apps data-lf-apps-pref="abajo|arriba"><summary>PedidosYa</summary><div class="lf-apps__menu">…
      Al abrir lo coloca donde quepa a la vista (primero el lado: a la derecha si se sale por ese lado; después hacia
      abajo o hacia arriba), mirando lo que lo recorta: el pie del cajón (se desplaza por dentro), la caja que lo
      contiene, las barras fijas del celular y el encabezado pegado. Si no cabe entero ni arriba ni abajo, desplaza lo
      justo el pie del cajón o la página. Se cierra con Escape (el foco vuelve al botón; el cajón del carro no se
      cierra), con un clic o toque fuera, al salir con Tab, al elegir una sucursal y al abrir otro.
*/
(() => {
  const body = document.body;
  let scrim = null;
  let lastTrigger = null;

  const getScrim = () => {
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'lf-scrim';
      scrim.hidden = true;
      scrim.addEventListener('click', () => closeAll());
      body.appendChild(scrim);
    }
    return scrim;
  };

  const openPanel = (panel, trigger) => {
    if (!panel) return;
    closeAll();
    lastTrigger = trigger || null;
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('lf-is-open'));
    panel.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    getScrim().hidden = false;
    body.classList.add('lf-no-scroll');
    const focusable = panel.querySelector('[autofocus], input, button, a[href]');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 60);
  };

  const closePanel = (panel) => {
    if (!panel || panel.hidden) return;
    panel.classList.remove('lf-is-open');
    panel.setAttribute('aria-hidden', 'true');
    setTimeout(() => { panel.hidden = true; }, 220);
    document.querySelectorAll(`[data-lf-open="${panel.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
  };

  const closeAll = () => {
    document.querySelectorAll('.lf-panel.lf-is-open').forEach(closePanel);
    if (scrim) scrim.hidden = true;
    body.classList.remove('lf-no-scroll');
    if (lastTrigger) { lastTrigger.focus({ preventScroll: true }); lastTrigger = null; }
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-lf-open]');
    if (opener) {
      e.preventDefault();
      openPanel(document.getElementById(opener.dataset.lfOpen), opener);
      return;
    }
    if (e.target.closest('[data-lf-close]')) {
      e.preventDefault();
      closeAll();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  const initSticky = (root = document) => {
    root.querySelectorAll('[data-lf-sticky-watch]').forEach((bar) => {
      if (bar.dataset.lfStickyReady) return;
      const target = document.querySelector(bar.dataset.lfStickyWatch);
      if (!target || !('IntersectionObserver' in window)) return;
      bar.dataset.lfStickyReady = '1';
      const update = () => bar.classList.toggle('lf-is-visible', target.getBoundingClientRect().bottom < 0);
      new IntersectionObserver(update).observe(target);
      // Respaldo: un salto con ancla o un scroll restaurado puede pasar el elemento sin que el observador lo vea.
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { update(); ticking = false; });
      }, { passive: true });
      update();
    });
  };

  // 3. Menú de las apps de delivery ------------------------------------------------------------------------
  const APPS = 'details[data-lf-apps]';
  const visible = (el) => {
    const s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden';
  };
  // Rectángulo donde el menú se ve entero: la ventana, recortada por los contenedores que no dejan ver lo que se
  // sale (overflow) y por las barras fijas del celular (fuera del cajón, que las tapa).
  const zonaVisible = (dd) => {
    const z = { top: 0, bottom: window.innerHeight, left: 0, right: document.documentElement.clientWidth };
    for (let p = dd.parentElement; p && p !== document.body; p = p.parentElement) {
      const s = getComputedStyle(p);
      if (/(auto|scroll|hidden|clip)/.test(s.overflowX + ' ' + s.overflowY)) {
        const r = p.getBoundingClientRect();
        z.top = Math.max(z.top, r.top); z.bottom = Math.min(z.bottom, r.bottom);
        z.left = Math.max(z.left, r.left); z.right = Math.min(z.right, r.right);
      }
    }
    if (!dd.closest('cart-drawer, .lf-panel')) {
      // Una barra que está entrando (transición de transform) se mide donde va a quedar, no donde va pasando.
      document.querySelectorAll('.lf-tabbar, .lf-cpaybar, .lf-pdp-bar, .lf-rec__bar').forEach((b) => {
        const cs = getComputedStyle(b);
        if (!visible(b) || cs.position !== 'fixed') return;
        const r = b.getBoundingClientRect();
        const m = /matrix(3d)?\(([^)]+)\)/.exec(cs.transform || '');
        const ty = m ? parseFloat(m[2].split(',')[m[1] ? 13 : 5]) || 0 : 0;
        const top = r.top - ty;
        if (r.height && top > window.innerHeight / 2) z.bottom = Math.min(z.bottom, top);
      });
      // El encabezado queda pegado arriba (y se esconde al bajar): lo que quede bajo él no se ve
      document.querySelectorAll('.lf-section-header').forEach((h) => {
        if (!visible(h) || !/sticky|fixed/.test(getComputedStyle(h).position)) return;
        const r = h.getBoundingClientRect();
        if (r.height && r.bottom > 0 && r.top < window.innerHeight / 2) z.top = Math.max(z.top, r.bottom);
      });
    }
    return z;
  };
  // ¿Está dentro de un contenedor que se desplaza por dentro (p. ej. el pie del cajón en una pantalla baja)?
  const dentroDeAlgoQueSeDesplaza = (dd) => {
    for (let p = dd.parentElement; p && p !== document.body; p = p.parentElement) {
      if (/(auto|scroll)/.test(getComputedStyle(p).overflowY) && p.scrollHeight > p.clientHeight + 1) return true;
    }
    return false;
  };
  const colocarApps = (dd) => {
    const menu = dd.querySelector('.lf-apps__menu');
    const sum = dd.querySelector('summary');
    if (!menu || !sum) return;
    dd.classList.remove('lf-apps__dd--arriba', 'lf-apps__dd--der');
    // Primero el lado: abierto a la izquierda, un menú que se sale de la ventana a lo ancho hace que el celular aleje
    // la vista mientras se mide (innerHeight 844 → 1031 y la barra fija «baja»), y la dirección saldría mal.
    const b = sum.getBoundingClientRect();
    const ancho = document.documentElement.clientWidth;
    if (b.left + menu.offsetWidth > ancho - 4 && b.right - menu.offsetWidth >= 0) dd.classList.add('lf-apps__dd--der');
    const z = zonaVisible(dd);
    const alto = menu.offsetHeight + 8;
    const abajo = z.bottom - b.bottom;
    const arriba = b.top - z.top;
    let dir = dd.dataset.lfAppsPref === 'arriba' ? 'arriba' : 'abajo';
    if (dir === 'abajo' && abajo < alto && arriba > abajo) dir = 'arriba';
    else if (dir === 'arriba' && arriba < alto && abajo > arriba) dir = 'abajo';
    // No cabe hacia ningún lado en la página: hacia abajo, así lo que falta se gana bajando y el encabezado (que
    // vuelve al subir y taparía el menú) sigue escondido. En el cajón o en algo que se desplaza por dentro, no.
    if (abajo < alto && arriba < alto && !dd.closest('cart-drawer, .lf-panel') && !dentroDeAlgoQueSeDesplaza(dd)) dir = 'abajo';
    dd.classList.toggle('lf-apps__dd--arriba', dir === 'arriba');
    const m = menu.getBoundingClientRect();
    if (m.right > z.right - 4 && b.right - m.width >= z.left) dd.classList.add('lf-apps__dd--der');
    // Si igual no cabe entero (pantalla muy baja), se desplaza lo justo: lo que lo contiene si se desplaza por dentro
    // (el pie del cajón) o, si no, la página, contando las barras fijas y el encabezado (scrollIntoView no los ve).
    const r = menu.getBoundingClientRect();
    if (r.top < z.top || r.bottom > z.bottom) {
      if (dd.closest('cart-drawer, .lf-panel') || dentroDeAlgoQueSeDesplaza(dd)) {
        try { menu.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) { /* navegador antiguo */ }
      } else {
        // Se corta abajo: la página avanza lo que falta (al avanzar, el encabezado pegado se esconde y deja sitio
        // arriba); se corta solo arriba: retrocede lo que falta.
        window.scrollBy(0, Math.round(r.bottom > z.bottom ? r.bottom - z.bottom : r.top - z.top));
      }
    }
  };
  const cerrarApps = (excepto) => {
    document.querySelectorAll(APPS + '[open]').forEach((d) => { if (d !== excepto) d.open = false; });
  };
  document.addEventListener('click', (e) => {
    const dd = e.target.closest(APPS);
    cerrarApps(dd);   // clic o toque fuera: se cierra el que esté abierto
    if (!dd) return;
    const sum = e.target.closest('summary');
    if (sum && sum.parentElement === dd) {
      e.preventDefault();   // se abre a mano para colocarlo antes de que se pinte
      dd.open = !dd.open;
      if (dd.open) colocarApps(dd);
    } else if (e.target.closest('.lf-apps__op')) {
      setTimeout(() => { dd.open = false; }, 0);   // eligió la sucursal (se abre en otra pestaña)
    }
  });
  document.addEventListener('focusout', (e) => {
    const dd = e.target.closest ? e.target.closest(APPS) : null;
    if (dd && dd.open && e.relatedTarget && !dd.contains(e.relatedTarget)) dd.open = false;
  });
  // Escape: cierra el menú y devuelve el foco a su botón, sin cerrar además el cajón del carro (que cierra con
  // keyup) ni los paneles (keydown de arriba): se captura en el documento antes que ellos.
  let escapeDelMenu = false;
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const abiertos = Array.from(document.querySelectorAll(APPS + '[open]'));
    if (!abiertos.length) return;
    const dd = abiertos.find((d) => d.contains(document.activeElement)) || abiertos[0];
    cerrarApps();
    const sum = dd.querySelector('summary');
    if (sum) sum.focus({ preventScroll: true });
    escapeDelMenu = true;
    e.preventDefault();
    e.stopPropagation();
  }, true);
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' && escapeDelMenu) {
      escapeDelMenu = false;
      e.stopPropagation();
    }
  }, true);
  // Al girar o cambiar el ancho, la posición ya no vale (el alto cambia solo con la barra del navegador: se ignora)
  let anchoApps = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === anchoApps) return;
    anchoApps = window.innerWidth;
    cerrarApps();
  });

  window.LF = { openPanel, closePanel, closeAll, initSticky };
  initSticky();
  document.addEventListener('shopify:section:load', (e) => initSticky(e.target));
})();
